<template>
    <div
        class="btns"
        :class="{
            'btns_mobile': isMobile
        }"
    >
        <v-btn
            v-for="(item, key) in items"
            :key="key"
            color="secondary"
            :small="!isMobile"
            :to="item.to"
            exact
            @click="btnClick(item.click)"
            height="40"
            elevation="0"
        >
            <v-icon
                v-if="item.type === 'back'"
                size="16"
            >mdi-chevron-left</v-icon>
            <template
                v-if="item.type === 'back'"
            >{{ item.label ? item.label : $t('msg.back') }}</template>
            <template v-else>{{ item.label }}</template>
        </v-btn>
    </div>
</template>

<script>
export default {
    props: {
        items: {type: Array, default: () => []}
    },
    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.xs;
        }
    },
    methods: {
      btnClick(fn) {
        if (typeof fn === 'function') {
          fn();
        }
      }
    }
}
</script>

<style lang="scss">
.btns {
    .v-btn {
        color: #333 !important;
        font-size: 11px;
        font-weight: 400;
        margin-right: 15px;

        &:last-child {
            margin-right: 0;
        }
    }
    &.btns_mobile {
        .v-btn {
            width: 100%;
            margin-right: 0;
            margin-bottom: 15px;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}
</style>